var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "editarBasic", attrs: { row: "", "justify-center": "" } },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      },
                                      attrs: { md12: "" }
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "h2_title",
                                          staticStyle: {
                                            "margin-top": "12px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.esEdicion
                                                  ? "Editar Dual Stream"
                                                  : "Ver Detalle Dual Stream Streamax"
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm.esEdicion
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-grabar",
                                              attrs: { depressed: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.confirmCallbackConfirm(
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Guardar Cambios")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.hddDoubleRecording
                                              .label,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.hddDoubleRecording
                                              .check,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.hddDoubleRecording,
                                              "check",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.hddDoubleRecording.check"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg11: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-subheader",
                                        {
                                          staticClass:
                                            "v-subheader-velocidad v-label v-label--active theme--light"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formFields.hddRecordDuration
                                                .label
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm1: "",
                                        md1: "",
                                        lg1: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Main")
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg9: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-slider", {
                                        attrs: {
                                          "hide-details": "",
                                          min: "0",
                                          max: "100",
                                          "thumb-size": 24,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.hddRecordDuration
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.hddRecordDuration,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.hddRecordDuration.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm1: "",
                                        md1: "",
                                        lg1: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Sub")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.sdWriteResourceRatio
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.sdWriteResourceRatio
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields
                                                .sdWriteResourceRatio,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.sdWriteResourceRatio.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm1: "",
                                        md1: "",
                                        lg3: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Record Storage")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm4: "",
                                        md4: "",
                                        lg4: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.recordStorage
                                              .labelcheck1,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.recordStorage
                                              .internalSd,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.recordStorage,
                                              "internalSd",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.recordStorage.internalSd"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm4: "",
                                        md4: "",
                                        lg5: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.recordStorage
                                              .labelcheck2,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.recordStorage
                                              .externalSd,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.recordStorage,
                                              "externalSd",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.recordStorage.externalSd"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.recordMode.label,
                                          items:
                                            _vm.formFields.recordMode.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedRecordMode,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.recordMode.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.recordMode,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.recordMode.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg3: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Sub-Stream CH")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.subStreamCH
                                              .labelcheck1,
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[1],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 1, $$v)
                                          },
                                          expression: "checkboxes[1]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.subStreamCH
                                              .labelcheck2,
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[2],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 2, $$v)
                                          },
                                          expression: "checkboxes[2]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.subStreamCH
                                              .labelcheck3,
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[3],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 3, $$v)
                                          },
                                          expression: "checkboxes[3]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.subStreamCH
                                              .labelcheck4,
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[4],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 4, $$v)
                                          },
                                          expression: "checkboxes[4]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.subStreamCH
                                              .labelcheck5,
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.checkboxes[5],
                                          callback: function($$v) {
                                            _vm.$set(_vm.checkboxes, 5, $$v)
                                          },
                                          expression: "checkboxes[5]"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm4: "",
                                        md4: "",
                                        lg3: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Sub-Record")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          items: _vm.tablaDatos,
                                          headers: _vm.headers,
                                          "item-value": "canal",
                                          "hide-actions": ""
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.item.canal)
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: { disabled: true },
                                                      model: {
                                                        value: props.item.dato1,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "dato1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.dato1"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label:
                                                          props.item.label2,
                                                        items: props.item.dato2,
                                                        "item-text": "label",
                                                        "item-value": "id",
                                                        disabled: true
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.value2,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "value2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.value2"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label:
                                                          props.item.label3,
                                                        items: props.item.dato3,
                                                        "item-text": "label",
                                                        "item-value": "id",
                                                        disabled: true
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.value3,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "value3",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.value3"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label:
                                                          props.item.label4,
                                                        items: props.item.dato4,
                                                        "item-text": "label",
                                                        "item-value": "id",
                                                        disabled: true
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.value4,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "value4",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.value4"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label:
                                                          props.item.label5,
                                                        items: props.item.dato5,
                                                        "item-text": "label",
                                                        "item-value": "id",
                                                        disabled: true
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.value5,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "value5",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.value5"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label:
                                                          props.item.label6,
                                                        items: props.item.dato6,
                                                        "item-text": "label",
                                                        "item-value": "id",
                                                        disabled: true
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.value6,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "value6",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.value6"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.crud.editarCamara.titulo"),
          mensaje: _vm.$t("mensajes.crud.editarCamara.mensaje"),
          textoBtnSi: _vm.$t("mensajes.crud.editarCamara.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editarCamara.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.grabarEdicion($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }